import styled from 'styled-components';

const Icon = styled.span`
  font-family: 'SSGizmo';
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  text-rendering: optimizeLegibility;
  white-space: nowrap;
  font-feature-settings: 'liga';
  line-height: 1;
  ${({ content }) =>
    content &&
    `
    &::before {
      content: '${content}';
    }
  `};
`;

export const UsersIcon = styled(Icon)`
  &::before {
    content: '👥';
  }
`;

export const FlagIcon = styled(Icon)`
  &::before {
    content: '⚑';
  }
`;

export const NotebookIcon = styled(Icon)`
  &::before {
    content: '📓';
  }
`;
export const LockIcon = styled(Icon)`
  &::before {
    content: '🔒';
  }
`;
export default Icon;
